// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 279) return "../css/7.0.32801-account-summary.min.css";
	if (chunkId === 60) return "../css/7.0.32801-invite-user.min.css";
	if (chunkId === 167) return "../css/7.0.32801-account-comments.min.css";
	// return url for filenames based on template
	return undefined;
};